import { render, staticRenderFns } from "./ElCarouselV3.vue?vue&type=template&id=560179f8"
import script from "./ElCarouselV3.vue?vue&type=script&lang=js"
export * from "./ElCarouselV3.vue?vue&type=script&lang=js"
import style0 from "./ElCarouselV3.vue?vue&type=style&index=0&id=560179f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports